export const config = {
  title: "That's awesome!",
  colums: 3,
  columnWidth: 300,
  gridGap: 16,
  sectionGap: 48,
  chunkSize: 25,
  searchDebounceTimeMs: 100,
  giphyApiKey: "MWX7MTpmBt7la79zzebfux1DBvz2SbMO",
} as const
